import React from "react"
import { useTranslation } from 'react-i18next';

function NieuweInterfacesTabel(props){
    const { t } = useTranslation();

    return(
                <div class="col-span-6 m-3 rounded-lg">
                    <div class="mb-2 font-bold">
                        {t('dashboard.newInterfaces')}
                    </div>
                    <div class="inline-block rounded-lg w-full bg-blue-100 border-2 border-black shadow-2xl">
                        <table name="nieuwInterfacesTable" class="w-full">
                            <thead>
                                <tr class="bg-blue-200">
                                    <td class="font-semibold ">{t('dashboard.name')}</td>
                                    <td class="font-semibold ">{t('dashboard.subscriptionName')}</td>
                                    <td class="font-semibold ">{t('interface.sender')}</td>
                                    <td class="font-semibold ">{t('interface.receiver')}</td>
                                    <td class="font-semibold ">{t('subscriptions.status')}</td>
                                    <td class="font-semibold ">{t('subscriptions.startDate')}</td>
                                    <td class="font-semibold ">{t('subscriptions.endDate')}</td>
                                    <td class="font-semibold ">{t('dashboard.sentCount')}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {props.newInterfaces.length>0&& props.newInterfaces.sort((a, b) => a.interface.omschrijving.localeCompare(b.interface.omschrijving)).map(interfaceObj =>
                                                <tr className ='bg-blue-200 border-black border'>
                                                    <td>{interfaceObj.interface.omschrijving}</td>
                                                    <td>{interfaceObj.abonnementNaam}</td>
                                                    <td>{interfaceObj.interface.verzenderNaam}</td>
                                                    <td>{interfaceObj.interface.ontvangerNaam}</td>
                                                    <td>{interfaceObj.interface.status}</td>
                                                    {interfaceObj.interface.startdatum ? (
                                                        <td>{interfaceObj.interface.startdatum.toString().split("T")[0]}</td>
                                                    ) : (
                                                        <td/>
                                                    )}
                                                    {interfaceObj.interface.einddatum ? (
                                                        <td>{interfaceObj.interface.einddatum.toString().split("T")[0]}</td>
                                                    ) : (
                                                        <td/>
                                                    )}
                                                    <td>{interfaceObj.interface.aantalBerichten}</td>
                                                </tr>
                                        
                                    )}
                                </tbody>
                        </table>
                    </div>
                </div>
    )
}
export default NieuweInterfacesTabel;